{
  "uk": {
    "Yes": "Так",
    "No": "Ні",
    "Cancel": "Скасування",
    "Clear": "Очистити",
    "Done": "Готово",
    "Loading": "Завантаження ...",
    "Select": "Обрати ...",
    "Search": "Пошук",
    "Back": "Назад",
    "OK": "OK",
    "dxCollectionWidget-noDataText": "Немає даних для відображення",
    "dxDropDownEditor-selectLabel": "Обрати",
    "validation-required": "Поле необхідно заповнити",
    "validation-required-formatted": "Необхідно заповнити: {0}",
    "validation-numeric": "Значення має бути числом",
    "validation-numeric-formatted": "Значення поля {0} має бути числом",
    "validation-range": "Значення поля не входить в діапазон",
    "validation-range-formatted": "Значення поля {0} не входить в діапазон",
    "validation-stringLength": "Невірна довжина значення в поле",
    "validation-stringLength-formatted": "Невірна довжина значення в поле {0}",
    "validation-custom": "Неприпустиме значення",

    "validation-custom-formatted": "Неприпустиме значення: {0}",
    "validation-async": "Неприпустиме значення",
    "validation-async-formatted": "Неприпустиме значення: {0}",
    "validation-compare": "Значення полів не відповідають один одному.",
    "validation-compare-formatted": "Значення поля {0} не відповідає",
    "validation-pattern": "Значення не відповідає шаблоном",
    "validation-pattern-formatted": "Значення поля {0} не відповідає шаблоном",
    "validation-email": "Неприпустиме значення email",
    "validation-email-formatted": "Неприпустиме значеніe {0}",
    "validation-mask": "Неприпустиме значення",
    "dxLookup-searchPlaceholder": "Мінімальна кількість символів: {0}",
    "dxList-pullingDownText": "Потягніть, щоб оновити ...",
    "dxList-pulledDownText": "Відпустіть, щоб оновити ...",
    "dxList-refreshingText": "Оновлення ...",
    "dxList-pageLoadingText": "Завантаження ...",

    "dxList-nextButtonText": "Далі",
    "dxList-selectAll": "Обрати все",
    "dxListEditDecorator-delete": "Видалити",
    "dxListEditDecorator-more": "Ще",
    "dxScrollView-pullingDownText": "Потягніть, щоб оновити ...",
    "dxScrollView-pulledDownText": "Відпустіть, щоб оновити ...",
    "dxScrollView-refreshingText": "Оновлення ...",
    "dxScrollView-reachBottomText": "Завантаження ...",
    "dxDateBox-simulatedDataPickerTitleTime": "Виберіть час",
    "dxDateBox-simulatedDataPickerTitleDate": "Виберіть дату",
    "dxDateBox-simulatedDataPickerTitleDateTime": "Виберіть дату та час",
    "dxDateBox-validation-datetime": "Значення має бути датою / часом",
    "dxFileUploader-selectFile": "Оберіть файл",
    "dxFileUploader-dropFile": "або Перетягніть файл сюди",

    "dxFileUploader-bytes": "байт",
    "dxFileUploader-kb": "кБ",
    "dxFileUploader-Mb": "МБ",
    "dxFileUploader-Gb": "ГБ",
    "dxFileUploader-upload": "Завантажити",
    "dxFileUploader-uploaded": "Завантажено",
    "dxFileUploader-readyToUpload": "Готово до завантаження",
    "dxFileUploader-uploadFailedMessage": "Завантаження не вдалася",
    "dxFileUploader-invalidFileExtension": "Неприпустиме розширення файлу",
    "dxFileUploader-invalidMaxFileSize": "Файл занадто великий",
    "dxFileUploader-invalidMinFileSize": "Файл занадто маленький",
    "dxRangeSlider-ariaFrom": "Від",
    "dxRangeSlider-ariaTill": "До",
    "dxSwitch-switchedOnText": "ВКЛ",
    "dxSwitch-switchedOffText": "OFF",
    "dxForm-optionalMark": "Необов'язковий",
    "dxForm-requiredMessage": "Поле {0} не може залишатися порожнім",
    "dxNumberBox-invalidValueMessage": "Значення має бути числом",
    "dxNumberBox-noDataText": "Інформація відсутня",
    "dxDataGrid-columnChooserTitle": "Вибір стовпців",
    "dxDataGrid-columnChooserEmptyText": "Перетягніть стовпець сюди, щоб приховати його",
    "dxDataGrid-groupContinuesMessage": "Продовження на наступній сторінці",
    "dxDataGrid-groupContinuedMessage": "Продовження з попередньої сторінки",

    "dxDataGrid-groupHeaderText": "Згрупувати дані по цьому стовпцю",
    "dxDataGrid-ungroupHeaderText": "Розгрупувати дані з цього стовпцю",
    "dxDataGrid-ungroupAllText": "Скинути групування",
    "dxDataGrid-editingEditRow": "Редагувати",
    "dxDataGrid-editingSaveRowChanges": "Зберегти",
    "dxDataGrid-editingCancelRowChanges": "Скасувати",
    "dxDataGrid-editingDeleteRow": "Видалити",
    "dxDataGrid-editingUndeleteRow": "Відновити",
    "dxDataGrid-editingConfirmDeleteMessage": "Ви впевнені, що хочете видалити цей запис?",
    "dxDataGrid-validationCancelChanges": "Відмовитися від змін",
    "dxDataGrid-groupPanelEmptyText": "Перетягніть стовпець сюди, щоб згрупувати по ньому",
    "dxDataGrid-noDataText": "Інформація відсутня",
    "dxDataGrid-searchPanelPlaceholder": "Шукати ...",
    "dxDataGrid-filterRowShowAllText": "(Всі)",
    "dxDataGrid-filterRowResetOperationText": "Скинути",
    "dxDataGrid-filterRowOperationEquals": "Дорівнює",
    "dxDataGrid-filterRowOperationNotEquals": "Не дорівнює",
    "dxDataGrid-filterRowOperationLess": "Менше",
    "dxDataGrid-filterRowOperationLessOrEquals": "Менше або дорівнює",
    "dxDataGrid-filterRowOperationGreater": "Більше",

    "dxDataGrid-filterRowOperationGreaterOrEquals": "Більше або дорівнює",
    "dxDataGrid-filterRowOperationStartsWith": "Починається з",
    "dxDataGrid-filterRowOperationContains": "Містить",
    "dxDataGrid-filterRowOperationNotContains": "Не містить",
    "dxDataGrid-filterRowOperationEndsWith": "Закінчується на",
    "dxDataGrid-filterRowOperationBetween": "В діапазоні",
    "dxDataGrid-filterRowOperationBetweenStartText": "Початок",
    "dxDataGrid-filterRowOperationBetweenEndText": "Кінець",
    "dxDataGrid-applyFilterText": "Застосувати фільтр",
    "dxDataGrid-trueText": "Так",
    "dxDataGrid-falseText": "Ні",
    "dxDataGrid-sortingAscendingText": "Сортувати за зростанням",
    "dxDataGrid-sortingDescendingText": "Сортувати за спаданням",
    "dxDataGrid-sortingClearText": "Очистити сортування",
    "dxDataGrid-editingSaveAllChanges": "Зберегти зміни",
    "dxDataGrid-editingCancelAllChanges": "Відмовитися від змін",
    "dxDataGrid-editingAddRow": "Додати рядок",

    "dxDataGrid-summaryMin": "Мін: {0}",
    "dxDataGrid-summaryMinOtherColumn": "Мін по {1}: {0}",
    "dxDataGrid-summaryMax": "Макс: {0}",
    "dxDataGrid-summaryMaxOtherColumn": "Макс по {1}: {0}",
    "dxDataGrid-summaryAvg": "СРЗНАЧ: {0}",
    "dxDataGrid-summaryAvgOtherColumn": "СРЗНАЧ по {1}: {0}",
    "dxDataGrid-summarySum": "Сум: {0}",
    "dxDataGrid-summarySumOtherColumn": "Сум за {1}: {0}",
    "dxDataGrid-summaryCount": "Кількість: {0}",
    "dxDataGrid-columnFixingFix": "Закріпити",
    "dxDataGrid-columnFixingUnfix": "Відмінити закріплення",
    "dxDataGrid-columnFixingLeftPosition": "Наліво",
    "dxDataGrid-columnFixingRightPosition": "Направо",
    "dxDataGrid-exportTo": "Експортувати",
    "dxDataGrid-exportToExcel": "Експортувати в Excel файл",
    "dxDataGrid-exporting": "Експорт ...",
    "dxDataGrid-excelFormat": "Excel файл",
    "dxDataGrid-selectedRows": "Обрані рядки",
    "dxDataGrid-exportAll": "Експортувати все",
    "dxDataGrid-exportSelectedRows": "Експортувати вибрані рядки",
    "dxDataGrid-headerFilterEmptyValue": "(Пусте)",
    "dxDataGrid-headerFilterOK": "ОК",
    "dxDataGrid-headerFilterCancel": "Скасувати",
    "dxDataGrid-ariaColumn": "Стовпець",
    "dxDataGrid-ariaValue": "Значення",

    "dxDataGrid-ariaFilterCell": "Фільтр",
    "dxDataGrid-ariaCollapse": "Згорнути",
    "dxDataGrid-ariaExpand": "Розгорнути",
    "dxDataGrid-ariaDataGrid": "Таблиця даних",
    "dxDataGrid-ariaSearchInGrid": "Шукати в таблиці даних",
    "dxDataGrid-ariaSelectAll": "Вибрати все",
    "dxDataGrid-ariaSelectRow": "Вибрати рядок",
    "dxDataGrid-filterBuilderPopupTitle": "Конструктор фільтра",
    "dxDataGrid-filterPanelCreateFilter": "Створити фільтр",
    "dxDataGrid-filterPanelClearFilter": "Очистити",
    "dxDataGrid-filterPanelFilterEnabledHint": "Активувати фільтр",
    "dxTreeList-ariaTreeList": "Ієрархічна таблиця даних",
    "dxTreeList-editingAddRowToNode": "Додати",
    "dxPager-infoText": "Сторінка {0} з {1} (Всього елементів: {2})",
    "dxPager-pagesCountText": "з",
    "dxPivotGrid-grandTotal": "Разом",
    "dxPivotGrid-total": "{0} Всього",
    "dxPivotGrid-fieldChooserTitle": "Вибір полів",
    "dxPivotGrid-showFieldChooser": "Показати вибір полів",
    "dxPivotGrid-expandAll": "Розкрити всі",
    "dxPivotGrid-collapseAll": "Звернути усі",
    "dxPivotGrid-sortColumnBySummary": "Сортувати '{0}' по цій колонці",
    "dxPivotGrid-sortRowBySummary": "Сортувати '{0}' по цьому рядку",
    "dxPivotGrid-removeAllSorting": "Скинути все сортування",
    "dxPivotGrid-dataNotAvailable": "Н / Д",
    "dxPivotGrid-rowFields": "Поля рядків",
    "dxPivotGrid-columnFields": "Поля стовпців",
    "dxPivotGrid-dataFields": "Поля даних",
    "dxPivotGrid-filterFields": "Поля фільтрів",
    "dxPivotGrid-allFields": "Все поля",
    "dxPivotGrid-columnFieldArea": "Перетягніть поля колонок сюди",
    "dxPivotGrid-dataFieldArea": "Перетягніть поля даних сюди",
    "dxPivotGrid-rowFieldArea": "Перетягніть поля рядків сюди",
    "dxPivotGrid-filterFieldArea": "Перетягніть поля фільтрів сюди",
    "dxScheduler-editorLabelTitle": "Назва",
    "dxScheduler-editorLabelStartDate": "Дата початку",
    "dxScheduler-editorLabelEndDate": "Дата завершення",
    "dxScheduler-editorLabelDescription": "Опис",
    "dxScheduler-editorLabelRecurrence": "Повторення",
    "dxScheduler-openAppointment": "Відкрити завдання",
    "dxScheduler-recurrenceNever": "Ніколи",
    "dxScheduler-recurrenceMinutely": "Щохвилини",

    "dxScheduler-recurrenceHourly": "Щогодини",
    "dxScheduler-recurrenceDaily": "Щодня",
    "dxScheduler-recurrenceWeekly": "Щотижня",
    "dxScheduler-recurrenceMonthly": "Щомісяця",
    "dxScheduler-recurrenceYearly": "Щорічно",
    "dxScheduler-recurrenceRepeatEvery": "Інтервал",
    "dxScheduler-recurrenceRepeatOn": "Повторювати по",
    "dxScheduler-recurrenceEnd": "Завершити повторення",
    "dxScheduler-recurrenceAfter": "Після",
    "dxScheduler-recurrenceOn": "Повторювати до",
    "dxScheduler-recurrenceRepeatMinutely": "хвилин (хвилини)",
    "dxScheduler-recurrenceRepeatHourly": "годин (години)",
    "dxScheduler-recurrenceRepeatDaily": "днів (дня)",
    "dxScheduler-recurrenceRepeatWeekly": "тижні (тижнів)",
    "dxScheduler-recurrenceRepeatMonthly": "місяці (місяців)",
    "dxScheduler-recurrenceRepeatYearly": "року (років)",
    "dxScheduler-recurrenceRepeatOnDate": "До дати",
    "dxScheduler-recurrenceRepeatCount": "повторень",
    "dxScheduler-switcherDay": "День",
    "dxScheduler-switcherWeek": "Тиждень",
    "dxScheduler-switcherWorkWeek": "Робочий тиждень",
    "dxScheduler-switcherMonth": "Місяць",
    "dxScheduler-switcherTimelineDay": "Хронологія дня",
    "dxScheduler-switcherTimelineWeek": "Хронологія тижня",
    "dxScheduler-switcherTimelineWorkWeek": "Хронологія робочого тижня",
    "dxScheduler-switcherTimelineMonth": "Хронологія місяця",
    "dxScheduler-switcherAgenda": "Розклад",
    "dxScheduler-allDay": "Весь день",
    "dxScheduler-confirmRecurrenceEditMessage": "Ви хочете відредагувати тільки цю подію або всю серію?",
    "dxScheduler-confirmRecurrenceDeleteMessage": "Ви хочете видалити тільки цю подію або всю серію?",
    "dxScheduler-confirmRecurrenceEditSeries": "Всю серію",
    "dxScheduler-confirmRecurrenceDeleteSeries": "Всю серію",
    "dxScheduler-confirmRecurrenceEditOccurrence": "Тільки цю подію",
    "dxScheduler-confirmRecurrenceDeleteOccurrence": "Тільки цю подію",

    "dxScheduler-noTimezoneTitle": "Часовий пояс не обраний",
    "dxScheduler-moreAppointments": "і ще {0}",
    "dxCalendar-todayButtonText": "Сегодня",
    "dxCalendar-ariaWidgetName": "Календар",
    "dxColorView-ariaRed": "Червоний",
    "dxColorView-ariaGreen": "Зелений",
    "dxColorView-ariaBlue": "Синій",
    "dxColorView-ariaAlpha": "Прозорість",
    "dxColorView-ariaHex": "Код кольору",
    "dxTagBox-selected": "{0} вибрано",
    "dxTagBox-allSelected": "Вибрані всі ({0})",
    "dxTagBox-moreSelected": "і ще {0}",
    "vizExport-printingButtonText": "Друк",
    "vizExport-titleMenuText": "Експорт / Друк",
    "vizExport-exportButtonText": "{0} файл",
    "dxFilterBuilder-and": "І",
    "dxFilterBuilder-or": "Або",
    "dxFilterBuilder-notAnd": "Не І",
    "dxFilterBuilder-notOr": "Не Або",
    "dxFilterBuilder-addCondition": "Додати умова",
    "dxFilterBuilder-addGroup": "Додати групу",

    "dxFilterBuilder-enterValueText": "<введіть значення>",
    "dxFilterBuilder-filterOperationEquals": "Так само",
    "dxFilterBuilder-filterOperationNotEquals": "Не одно",
    "dxFilterBuilder-filterOperationLess": "Менше",
    "dxFilterBuilder-filterOperationLessOrEquals": "Менше або дорівнює",
    "dxFilterBuilder-filterOperationGreater": "Більше",
    "dxFilterBuilder-filterOperationGreaterOrEquals": "Більше або дорівнює",
    "dxFilterBuilder-filterOperationStartsWith": "Починається з",
    "dxFilterBuilder-filterOperationContains": "Містить",
    "dxFilterBuilder-filterOperationNotContains": "Не містить",
    "dxFilterBuilder-filterOperationEndsWith": "Закінчується на",
    "dxFilterBuilder-filterOperationIsBlank": "Порожньо",
    "dxFilterBuilder-filterOperationIsNotBlank": "Не порожньо",
    "dxFilterBuilder-filterOperationBetween": "В діапазоні",
    "dxFilterBuilder-filterOperationAnyOf": "Будь-який з",
    "dxFilterBuilder-filterOperationNoneOf": "Жоден з",
    "dxHtmlEditor-dialogColorCaption": "Змінити колір тексту",
    "dxHtmlEditor-dialogBackgroundCaption": "Змінити колір фону",
    "dxHtmlEditor-dialogLinkCaption": "Додати посилання",
    "dxHtmlEditor-dialogLinkUrlField": "URL",
    "dxHtmlEditor-dialogLinkTextField": "Текст",

    "dxHtmlEditor-dialogLinkTargetField": "Відкрити в новому вікні",
    "dxHtmlEditor-dialogImageCaption": "Додати зображення",
    "dxHtmlEditor-dialogImageUrlField": "URL",
    "dxHtmlEditor-dialogImageAltField": "Альтернативний текст",
    "dxHtmlEditor-dialogImageWidthField": "Ширина (px)",
    "dxHtmlEditor-dialogImageHeightField": "Висота (px)",
    "dxHtmlEditor-heading": "Тема",
    "dxHtmlEditor-normalText": "Звичайний текст",

    "dxFileManager-newDirectoryName": "Без назви",
    "dxFileManager-rootDirectoryName": "Файли",
    "dxFileManager-errorNoAccess": "Доступ заборонений. Операція не може бути завершена.",
    "dxFileManager-errorDirectoryExistsFormat": "Каталог {0} вже існує.",
    "dxFileManager-errorFileExistsFormat": "Файл {0} вже існує.",
    "dxFileManager-errorFileNotFoundFormat": "Файл {0} не найден.",
    "dxFileManager-errorDirectoryNotFoundFormat": "Каталог '{0}' не найден.",
    "dxFileManager-errorWrongFileExtension": "Неправильне розширення файлу.",
    "dxFileManager-errorMaxFileSizeExceeded": "Розмір файлу перевищує допустиме значення.",
    "dxFileManager-errorInvalidSymbols": "Введене ім'я містить неприпустимі символи.",
    "dxFileManager-errorDefault": "Невідома помилка",
    "dxFileManager-errorDirectoryOpenFailed": "Не вдалося відкрити каталог",

    "dxFileManager-commandCreate": "Нова папка",
    "dxFileManager-commandRename": "Перейменувати",
    "dxFileManager-commandMove": "Перемістити в",
    "dxFileManager-commandCopy": "Копіювати в",
    "dxFileManager-commandDelete": "Видалити",
    "dxFileManager-commandDownload": "Завантажити",
    "dxFileManager-commandUpload": "Завантажити файли",
    "dxFileManager-commandRefresh": "Оновити",
    "dxFileManager-commandThumbnails": "Режим ексиз",
    "dxFileManager-commandDetails": "Режим списку",
    "dxFileManager-commandClearSelection": "Очистити виділення",
    "dxFileManager-dialogButtonCancel": "Скасування",
    "dxFileManager-commandShowNavPane": "Переключити панель навігації",

    "dxFileManager-dialogDirectoryChooserMoveTitle": "Перемістити в",
    "dxFileManager-dialogDirectoryChooserMoveButtonText": "Перемістити",
    "dxFileManager-dialogDirectoryChooserCopyTitle": "Копіювати в",
    "dxFileManager-dialogDirectoryChooserCopyButtonText": "Копіювати",
    "dxFileManager-dialogRenameItemTitle": "Перейменувати",
    "dxFileManager-dialogRenameItemButtonText": "Зберегти",
    "dxFileManager-dialogCreateDirectoryTitle": "Нова папка",
    "dxFileManager-dialogCreateDirectoryButtonText": "Створити",
    "dxFileManager-dialogDeleteItemTitle": "Видалення елемента",
    "dxFileManager-dialogDeleteItemButtonText": "Видалити",
    "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Ви дійсно хочете видалити {0}?",
    "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Ви дійсно хочете видалити {0} елементів?",

    "dxFileManager-editingCreateSingleItemProcessingMessage": "Створюється папка в {0}",
    "dxFileManager-editingCreateSingleItemSuccessMessage": "Створена папка в {0}",
    "dxFileManager-editingCreateSingleItemErrorMessage": "Не вдалося створити папку",
    "dxFileManager-editingCreateCommonErrorMessage": "Не вдалося створити папку",

    "dxFileManager-editingRenameSingleItemProcessingMessage": "перейменовувати елемент в {0}",
    "dxFileManager-editingRenameSingleItemSuccessMessage": "Перейменований елемент в {0}",
    "dxFileManager-editingRenameSingleItemErrorMessage": "Не вдалося перейменувати елемент",
    "dxFileManager-editingRenameCommonErrorMessage": "Не вдалося перейменувати елемент",

    "dxFileManager-editingDeleteSingleItemProcessingMessage": "Елемент видаляється з {0}",
    "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Видалення {0} елементів з {1}",
    "dxFileManager-editingDeleteSingleItemSuccessMessage": "Елемент видалений з {0}",
    "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "{0} елементів видалено з {1}",
    "dxFileManager-editingDeleteSingleItemErrorMessage": "Не вдалося видалити елемент",
    "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} елементів не були видалені",
    "dxFileManager-editingDeleteCommonErrorMessage": "Деякі елементи не були видалені",

    "dxFileManager-editingMoveSingleItemProcessingMessage": "Елемент переміститься в {0}",
    "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Переміщення {0} елементів в {1}",
    "dxFileManager-editingMoveSingleItemSuccessMessage": "Елемент переміщений в {0}",
    "dxFileManager-editingMoveMultipleItemsSuccessMessage": "{0} елементів переміщено в {1}",
    "dxFileManager-editingMoveSingleItemErrorMessage": "Не вдалося перемістити елемент",
    "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} елементів не були переміщені",
    "dxFileManager-editingMoveCommonErrorMessage": "Деякі елементи не були переміщені",

    "dxFileManager-editingCopySingleItemProcessingMessage": "Елемент копіюється в {0}",
    "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Коіпрованіе {0} елементів в {1}",
    "dxFileManager-editingCopySingleItemSuccessMessage": "Елемент скопійований в {0}",
    "dxFileManager-editingCopyMultipleItemsSuccessMessage": "{0} елементів скопійовано в {1}",
    "dxFileManager-editingCopySingleItemErrorMessage": "Не вдалося скопіювати елемент",
    "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} елементів не були скопійовані",
    "dxFileManager-editingCopyCommonErrorMessage": "Деякі елементи не були скопійовані",

    "dxFileManager-editingUploadSingleItemProcessingMessage": "Елемент завантажується в {0}",
    "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Завантаження {0} елементів в {1}",
    "dxFileManager-editingUploadSingleItemSuccessMessage": "Елемент завантажений в {0}",
    "dxFileManager-editingUploadMultipleItemsSuccessMessage": "{0} елементів завантажено в {1}",
    "dxFileManager-editingUploadSingleItemErrorMessage": "Не вдалося завантажити елемент",
    "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} елементів не були завантажені",
    "dxFileManager-editingUploadCanceledMessage": "Скасовано",

    "dxFileManager-listDetailsColumnCaptionName": "Назва",
    "dxFileManager-listDetailsColumnCaptionDateModified": "Дата зміни",
    "dxFileManager-listDetailsColumnCaptionFileSize": "Розмір файлу",

    "dxFileManager-listThumbnailsTooltipTextSize": "Розмір",
    "dxFileManager-listThumbnailsTooltipTextDateModified": "Дата зміни",

    "dxFileManager-notificationProgressPanelTitle": "Прогрес",
    "dxFileManager-notificationProgressPanelEmptyListText": "Операції відсутні",
    "dxFileManager-notificationProgressPanelOperationCanceled": "Скасовано",

    "dxDiagram-categoryGeneral": "Загальні",
    "dxDiagram-categoryFlowchart": "Блок-схема",
    "dxDiagram-categoryOrgChart": "Організаційна схема",
    "dxDiagram-categoryContainers": "Контейнери",
    "dxDiagram-categoryCustom": "Призначені для користувача",

    "dxDiagram-commandExportToSvg": "Експорт в SVG",
    "dxDiagram-commandExportToPng": "Експорт в PNG",
    "dxDiagram-commandExportToJpg": "Експорт в JPEG",
    "dxDiagram-commandUndo": "Скасувати",
    "dxDiagram-commandRedo": "Повторити",
    "dxDiagram-commandFontName": "Назва шрифту",
    "dxDiagram-commandFontSize": "Розмір шрифту",
    "dxDiagram-commandBold": "Жирний",
    "dxDiagram-commandItalic": "Курсив",
    "dxDiagram-commandUnderline": "Підкреслений",
    "dxDiagram-commandTextColor": "Колір тексту",
    "dxDiagram-commandLineColor": "Колір лінії",
    "dxDiagram-commandLineWidth": "Ширина лінії",
    "dxDiagram-commandLineStyle": "Стиль лінії",
    "dxDiagram-commandLineStyleSolid": "Суцільна",
    "dxDiagram-commandLineStyleDotted": "Пунктирна",
    "dxDiagram-commandLineStyleDashed": "Штрихова",
    "dxDiagram-commandFillColor": "Колір заливки",

    "dxDiagram-commandAlignLeft": "Вирівнювання по лівому краю",
    "dxDiagram-commandAlignCenter": "Вирівнювання по центру",
    "dxDiagram-commandAlignRight": "Вирівнювання по правому краю",
    "dxDiagram-commandConnectorLineType": "Тип з'єднувача",
    "dxDiagram-commandConnectorLineStraight": "Прямий",
    "dxDiagram-commandConnectorLineOrthogonal": "Ортогональний",
    "dxDiagram-commandConnectorLineStart": "Тип початку з'єднувача",
    "dxDiagram-commandConnectorLineEnd": "Тип кінця з'єднувача",
    "dxDiagram-commandConnectorLineNone": "Ні",
    "dxDiagram-commandConnectorLineArrow": "Стрілка",
    "dxDiagram-commandFullscreen": "Повноекранний режим",
    "dxDiagram-commandUnits": "Одиниці виміру",
    "dxDiagram-commandPageSize": "Розмір сторінки",
    "dxDiagram-commandPageOrientation": "Орієнтація сторінки",
    "dxDiagram-commandPageOrientationLandscape": "Альбомна",
    "dxDiagram-commandPageOrientationPortrait": "Портретна",
    "dxDiagram-commandPageColor": "Колір сторінки",
    "dxDiagram-commandShowGrid": "Показувати сітку",
    "dxDiagram-commandSnapToGrid": "Прив'язка до сітки",
    "dxDiagram-commandGridSize": "Розмір сітки",
    "dxDiagram-commandZoomLevel": "Масштаб",
    "dxDiagram-commandAutoZoom": "Автомаштаб",
    "dxDiagram-commandFitToContent": "Вмістити по вмісту",
    "dxDiagram-commandFitToWidth": "Вмістити по ширині",
    "dxDiagram-commandAutoZoomByContent": "Автомаштаб по вмісту",
    "dxDiagram-commandAutoZoomByWidth": "Автомаштаб по ширині",
    "dxDiagram-commandSimpleView": "Спрощений вид",
    "dxDiagram-commandCut": "Вирізати",
    "dxDiagram-commandCopy": "Копіювати",
    "dxDiagram-commandPaste": "Вставити",
    "dxDiagram-commandSelectAll": "Виділити все",
    "dxDiagram-commandDelete": "Видалити",
    "dxDiagram-commandBringToFront": "На передній план",
    "dxDiagram-commandSendToBack": "На задній план",
    "dxDiagram-commandLock": "Заблокувати",
    "dxDiagram-commandUnlock": "Розблокувати",
    "dxDiagram-commandInsertShapeImage": "Додати зображення ...",
    "dxDiagram-commandEditShapeImage": "Змінити зображення ...",
    "dxDiagram-commandDeleteShapeImage": "Видалити зображення",
    "dxDiagram-commandLayoutLeftToRight": "Зліва направо",
    "dxDiagram-commandLayoutRightToLeft": "Справа наліво",
    "dxDiagram-commandLayoutTopToBottom": "Зверху вниз",
    "dxDiagram-commandLayoutBottomToTop": "Від низу до верху",

    "dxDiagram-unitIn": "дюйм (а)",
    "dxDiagram-unitCm": "см",
    "dxDiagram-unitPx": "піксель (я)",

    "dxDiagram-dialogButtonOK": "ОК",
    "dxDiagram-dialogButtonCancel": "Скасування",
    "dxDiagram-dialogInsertShapeImageTitle": "Додати зображення",
    "dxDiagram-dialogEditShapeImageTitle": "Змінити зображення",
    "dxDiagram-dialogEditShapeImageSelectButton": "Виберіть зображення",
    "dxDiagram-dialogEditShapeImageLabelText": "або перетягніть файл сюди",

    "dxDiagram-uiExport": "Експорт",
    "dxDiagram-uiProperties": "Властивості",
    "dxDiagram-uiSettings": "Налаштування",
    "dxDiagram-uiShowToolbox": "Панель інструментів",
    "dxDiagram-uiSearch": "Пошук",
    "dxDiagram-uiStyle": "Стиль",
    "dxDiagram-uiLayout": "Компонування",
    "dxDiagram-uiLayoutTree": "Деревовидна",
    "dxDiagram-uiLayoutLayered": "Багаторівнева",
    "dxDiagram-uiDiagram": "Діаграма",
    "dxDiagram-uiText": "Текст",
    "dxDiagram-uiObject": "Об'єкт",
    "dxDiagram-uiConnector": "З'єднувач",
    "dxDiagram-uiPage": "Сторінка",

    "dxDiagram-shapeText": "Текст",
    "dxDiagram-shapeRectangle": "Прямокутник",
    "dxDiagram-shapeEllipse": "Еліпс",
    "dxDiagram-shapeCross": "Хрест",
    "dxDiagram-shapeTriangle": "Трикутник",
    "dxDiagram-shapeDiamond": "Ромб",
    "dxDiagram-shapeHeart": "Серце",
    "dxDiagram-shapePentagon": "П'ятикутнику",
    "dxDiagram-shapeHexagon": "Шестиугольник",
    "dxDiagram-shapeOctagon": "Восьмиугольник",
    "dxDiagram-shapeStar": "Зірка",
    "dxDiagram-shapeArrowLeft": "Стрілка вліво",
    "dxDiagram-shapeArrowUp": "Стрілка вгору",
    "dxDiagram-shapeArrowRight": "Стрілка вправо",
    "dxDiagram-shapeArrowDown": "Стрілка вниз",
    "dxDiagram-shapeArrowUpDown": "Стрілка вгору-вниз",
    "dxDiagram-shapeArrowLeftRight": "Стрілка вліво-вправо",
    "dxDiagram-shapeProcess": "Процес",
    "dxDiagram-shapeDecision": "Рішення",
    "dxDiagram-shapeTerminator": "Термінатор",
    "dxDiagram-shapePredefinedProcess": "Зумовлений процес",
    "dxDiagram-shapeDocument": "Документ",
    "dxDiagram-shapeMultipleDocuments": "Документи",
    "dxDiagram-shapeManualInput": "Ручне введення",
    "dxDiagram-shapePreparation": "Підготовка",
    "dxDiagram-shapeData": "Дані",
    "dxDiagram-shapeDatabase": "База даних",
    "dxDiagram-shapeHardDisk": "Жорсткий диск",
    "dxDiagram-shapeInternalStorage": "Внутрішня пам'ять",
    "dxDiagram-shapePaperTape": "Паперова стрічка",
    "dxDiagram-shapeManualOperation": "Ручна операція",
    "dxDiagram-shapeDelay": "Затримка",
    "dxDiagram-shapeStoredData": "запам'ятовує дані",
    "dxDiagram-shapeDisplay": "Дисплей",
    "dxDiagram-shapeMerge": "Злиття",
    "dxDiagram-shapeConnector": "З'єднувач",
    "dxDiagram-shapeOr": "Або",
    "dxDiagram-shapeSummingJunction": "Підсумовування",
    "dxDiagram-shapeContainerDefaultText": "Контейнер",
    "dxDiagram-shapeVerticalContainer": "Вертикальний контейнер",
    "dxDiagram-shapeHorizontalContainer": "Горизонтальний контейнер",
    "dxDiagram-shapeCardDefaultText": "Ім'я людини",
    "dxDiagram-shapeCardWithImageOnLeft": "Картка із зображенням зліва",
    "dxDiagram-shapeCardWithImageOnTop": "Картка із зображенням зверху",
    "dxDiagram-shapeCardWithImageOnRight": "Картка із зображенням справа",

    "dxGantt-dialogTitle": "Назва",
    "dxGantt-dialogStartTitle": "Початок",
    "dxGantt-dialogEndTitle": "Закінчення",
    "dxGantt-dialogProgressTitle": "Прогрес",
    "dxGantt-dialogResourcesTitle": "Ресурси",
    "dxGantt-dialogResourceManagerTitle": "Управління ресурсами",
    "dxGantt-dialogTaskDetailsTitle": "Деталі завдання",
    "dxGantt-dialogEditResourceListHint": "Редагувати список ресурсів",
    "dxGantt-dialogEditNoResources": "Список ресурсів порожній",
    "dxGantt-dialogButtonAdd": "Додати",
    "dxGantt-contextMenuNewTask": "Нова задача",
    "dxGantt-contextMenuNewSubtask": "Нова подзадача",
    "dxGantt-contextMenuDeleteTask": "Видалити завдання",
    "dxGantt-contextMenuDeleteDependency": "Видалити залежність",
    "dxGantt-dialogTaskDeleteConfirmation": "Видалення завдання призведе до видалення всіх її залежностей і подзадач. Ви впевнені, що ви хочете видалити цю задачу?",
    "dxGantt-dialogDependencyDeleteConfirmation": "Ви впевнені, що хочете видалити цю залежність з завдання?",
    "dxGantt-dialogResourcesDeleteConfirmation": "Видалення ресурсу також видалить його з усіх завдань, в яких він використовується. Ви впевнені, що хочете видалити ці ресурси? Ресурси: {0}",
    "dxGantt-dialogConstraintCriticalViolationMessage": "Завдання, яке ви пересуваєте, має залежність від іншої задачі. Ця зміна суперечить правилам валідації. Як ви хочете вступити?",
    "dxGantt-dialogConstraintViolationMessage": "Завдання, яке ви пересуваєте, має залежність від іншої задачі. Як ви хочете вступити?",
    "dxGantt-dialogCancelOperationMessage": "Скасувати операцію",
    "dxGantt-dialogDeleteDependencyMessage": "Видалити завдання",
    "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Зберегти залежність і пересунути завдання",
    "dxGantt-undo": "Скасувати",
    "dxGantt-redo": "Повторити",
    "dxGantt-expandAll": "Розгорнути все",
    "dxGantt-collapseAll": "Звернути усі",
    "dxGantt-addNewTask": "Додати нову задачу",
    "dxGantt-deleteSelectedTask": "Видалити виділену задачу",
    "dxGantt-zoomIn": "Збільшити масштаб",
    "dxGantt-zoomOut": "Зменшити масштаб",
    "dxGantt-fullScreen": "Повноекранний режим"
  }
}
